import React, { useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { Panel } from "primereact/panel";
import { Sidebar } from "primereact/sidebar";

// import CompanyFormComponent from "../../components/2.0/company/CompanyFormComponent";
import CompanyListComponent from "../../components/2.1/settings/company/CompanyListComponent";
import CompanyFormComponent from "../../components/2.1/settings/company/CompanyFormComponent";
import UnitFormComponent from "../../components/2.1/settings/unit/UnitFormComponent";
import UnitListComponent from "../../components/2.1/settings/unit/UnitListComponent";
import UserListComponent from "../../components/2.1/settings/user/UserListComponent";
import UserFormComponent from "../../components/2.1/settings/user/UserFormComponent";
import ProjectstatusFormComponent from "../../components/2.0/projectstatus/ProjectstatusFormComponent"
import ProjecttypeFormComponent from "../../components/2.0/projecttype/ProjecttypeFormComponent";
import RolegroupListComponent from "../../components/2.0/rolegroup/RolegroupListComponent";
import RolegroupFormComponent from "../../components/2.0/rolegroup/RolegroupFormComponent";
import CalendartypeListComponent from "../../components/2.0/calendartype/CalendartypeListComponent";
import CalendartypeFormComponent from "../../components/2.0/calendartype/CalendartypeFormComponent";
import EmployeenationalityListComponent from "../../components/2.0/employeenationality/EmployeenationalityListComponent";
import EmployeenationalityFormComponent from "../../components/2.0/employeenationality/EmployeenationalityFormComponent";
import ActivitygroupListComponent from "../../components/2.0/activitygroup/ActivitygroupListComponent";
import ActivitygroupFormComponent from "../../components/2.0/activitygroup/ActivitygroupFormComponent";
import ActivitysubgroupFormComponent from "../../components/2.0/activitysubgroup/ActivitysubgroupFormComponent";
import DocumenttypeListComponent from "../../components/2.0/documenttype/DocumenttypeListComponent";
import DocumenttypeFormComponent from "../../components/2.0/documenttype/DocumenttypeFormComponent";
import DocumenttemplateListComponent from "../../components/2.0/documenttemplate/DocumenttemplateListComponent";
import DocumenttemplateFormComponent from "../../components/2.0/documenttemplate/DocumenttemplateFormComponent";
import EmploymentworkorderListComponent from "../../components/2.0/employmentworkorder/EmploymentworkorderListComponent";
import EmploymentworkorderFormComponent from "../../components/2.0/employmentworkorder/EmploymentworkorderFormComponent";
import UnasFormComponent from "../../components/2.0/unas/UnasFormComponent";
import UnasListComponent from "../../components/2.0/unas/UnasListComponent";
import BankaccountListComponent from "../../components/2.0/bankaccount/BankaccountListComponent";
import BankaccountFormComponent from "../../components/2.0/bankaccount/BankaccountFormComponent";
// import PricelistitemFormComponent from "../../components/2.0/pricelistitem/PricelistitemFormComponent";
// import PricelistitemListComponent from "../../components/2.0/pricelistitem/PricelistitemListComponent";
import EmploymenttypeListComponent from "../../components/2.0/employmenttype/EmploymenttypeListComponent";
import EmploymenttypeFormComponent from "../../components/2.0/employmenttype/EmploymenttypeFormComponent";
import ProjectitemstatusFormComponent from "../../components/2.0/projectitemstatus/ProjectitemstatusFormComponent";
import MetricsListComponent from "../../components/2.0/metrics/MetricsListComponent";
import MetricsFormComponent from "../../components/2.0/metrics/MetricsFormComponent";
import PricelistitemFormComponent from '../../components/2.1/settings/pricelistitem/PricelistitemFormComponent';
import PricelistitemListComponent from '../../components/2.1/settings/pricelistitem/PricelistitemListComponent';
import RolesFormComponent from '../../components/2.1/settings/rolegroup/RolesFormComponent';
import RolesListComponent from '../../components/2.1/settings/rolegroup/RolesListComponent';
import IdentifierFormComponent from '../../components/2.1/settings/identifier/IdentifierFormComponent';
import IdentifierListComponent from '../../components/2.1/settings/identifier/IdentifierListComponent';
import ProjectListComponent from '../../components/2.1/project/ProjectListComponent';
import EmployeeListComponent from '../../components/2.1/hr/empoloyee/EmployeeListComponent';

import LocationListComponent from "../../components/2.1/settings/location/LocationListComponent";
import LocationFormComponent from "../../components/2.1/settings/location/LocationFormComponent";
import SettingsDashboardComponent from '../../components/2.1/settings/SettingsDashboardComponent';
import DashboardTemplateListComponent from '../../components/2.1/settings/dashboardtemplate/DashboardTemplateListComponent';
import DashboardTemplateShowComponent from '../../components/2.1/settings/dashboardtemplate/DashboardTemplateShowComponent';
import DashboardTemplateFormComponent from '../../components/2.1/settings/dashboardtemplate/DashboardTemplateFormComponent';
import LanguageFormComponent from '../../components/2.1/recruitment/language/LanguageFormComponent';
import LanguageListComponent from '../../components/2.1/recruitment/language/LanguageListComponent';

export const SettingsPage = (props) => {

  const { t } = props;
  const history = useHistory();
  const { entity, action, id } = useParams();

  const roles = localStorage.getItem('roles')?.toString() || '';
  
  useEffect(() => {
    document.title = t('App\\Settings') + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('settings')[0]) {
        document.getElementsByClassName('settings')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerenderSettingsPage]);

  return (
    <div className={"SettingsPage"}>
      {localStorage.getItem('module_settings') ? (
        <>
          {entity === 'dashboard' && roles.includes('role_settings_dashboard') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <SettingsDashboardComponent />
            </div>
          }
          {!entity && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-text-center">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('settingsSelectType')}
                  </h2>
                </div>
              </div>
            </div>
          )}

          {/* {entity === 'identifier' && roles.includes('role_identifier_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('identifiers')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/identifier/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('addIdentifier')}
                  </a>
                </div>
              </div>
              <Panel>
                <IdentifierListComponent view="simple" />
              </Panel>
            </div>
          )} */}

          {entity === 'user' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_user_read') && 
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('userList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                  {localStorage.getItem('roles').toString().includes('role_user_write') && (
                    <a onClick={() => {
                      history.push('/settings/user/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addUser')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <UserListComponent backlink={'/settings/user'}/>
              </Panel>
            </div>
          }
          {entity === 'user' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '1880px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/settings/user')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('userUpdate') : t('userCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/settings/user')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <UserFormComponent backlink={'/settings/user'}/>
                  }
                </Panel>
              </div>





            </Sidebar>
          }

          {entity === 'company' && roles.includes('role_company_read') && (!action || action === 'list') && localStorage.getItem('roles').toString().includes('role_company_read') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('companyList')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  {localStorage.getItem('roles').toString().includes('role_company_create') && (
                    <a
                      onClick={() => window.App.setState({ sidebarCompanyCreate: true, props: null })}
                      className="p-button  p-button-success p-ml-2"
                    >
                      <i className="pi pi-plus" />
                      &nbsp;
                      {t('addCompany')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CompanyListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'bankaccount' && roles.includes('role_bankaccount_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('bankAccounts')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/bankaccount/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('addBankAccountShort')}
                  </a>
                </div>
              </div>
              <Panel>
                <BankaccountListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'rolegroup' && roles.includes('role_role_group_read') && (!action || action === 'list') && ( localStorage.getItem('roles').toString().includes('role_role_group_read') && 
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('roles')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  {localStorage.getItem('roles').toString().includes('role_role_group_write') && (
                    <a
                      onClick={() => history.push('/settings/rolegroup/create')}
                      className="p-button  p-button-success p-ml-2"
                    >
                      <i className="pi pi-plus" />
                      &nbsp;
                      {t('addRole')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <RolegroupListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'unit' && roles.includes('role_unit_read') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('unitOfMeasures')}
                  </h2>
                </div>
                {(!action || action === 'list' || action === 'create' || action === 'update') && (
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <span className="p-mr-2" />
                    {localStorage.getItem('roles').toString().includes('role_unit_write') && (
                      <a
                        onClick={() => history.push('/settings/unit/create')}
                        className="p-button  p-button-success p-ml-2"
                      >
                        <i className="pi pi-plus" />
                        &nbsp;
                        {t('addUnitOfMeasure')}
                      </a>
                    )}
                  </div>
                )}
              </div>
              <Panel>
                <UnitListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'language' && roles.includes('role_language_read') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">{t('languages')}</h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  {roles.includes('role_language_write') && (
                    <a onClick={() => history.push('/settings/language/create')} className="p-button p-button-success p-ml-2">
                      <i className="pi pi-plus" />&nbsp;{t('addLanguage')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <LanguageListComponent backlink="/settings/language" />
              </Panel>
            </div>
          )}

          {entity === 'document-type' && roles.includes('role_document_type_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('documentTypes')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/document-type/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('documentTypeCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <DocumenttypeListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'document-template' && roles.includes('role_document_template_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    Dokumentum sablonok
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/document-template/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('documentTemplateCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <DocumenttemplateListComponent view="simple" />
              </Panel>
            </div>
          )}          

          {entity === 'calendar-type' && roles.includes('role_event_type_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('eventTypeList')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/calendar-type/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('eventTypeCreateSpaced')}
                  </a>
                </div>
              </div>
              <Panel>
                <CalendartypeListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'employee-nationality' && roles.includes('role_employee_nationality_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('citizenships')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/employee-nationality/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('citizenshipCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <EmployeenationalityListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'activity' && roles.includes('role_activity_group_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('activities')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/activity/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('activityCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <ActivitygroupListComponent />
              </Panel>
            </div>
          )}

          {entity === 'employment-workorder' && roles.includes('role_employment_work_order_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    Munkarendek
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/employment-workorder/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('workScheduleCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <EmploymentworkorderListComponent />
              </Panel>
            </div>
          )}

          {entity === 'employment-type' && roles.includes('role_employment_type_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('employmentForms')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/employment-type/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('employmentFormCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <EmploymenttypeListComponent />
              </Panel>
            </div>
          )}

          {entity === 'unas' && roles.includes('role_unas_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    UNAS
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/unas/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('unasConnectionCreate')}
                  </a>
                </div>
              </div>
              <Panel>
                <UnasListComponent />
              </Panel>
            </div>
          )}

          {entity === 'pricelistitem' && roles.includes('role_pricelist_item_read') && (!action || action === 'list') && localStorage.getItem('roles').toString().includes('role_price_list_item_read') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('priceLists')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  {localStorage.getItem('roles').toString().includes('role_price_list_item_write') && (
                    <a
                      onClick={() => history.push('/settings/pricelistitem/create')}
                      className="p-button  p-button-success p-ml-2"
                    >
                      <i className="pi pi-plus" />
                      &nbsp;
                      {t('addPriceList')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <PricelistitemListComponent />
              </Panel>
            </div>
          )}

          {entity === 'metrics' && roles.includes('role_project_read') && (!action || action === 'list') && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('metrics')}
                  </h2>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <span className="p-mr-2" />
                  <a
                    onClick={() => history.push('/settings/metrics/create')}
                    className="p-button  p-button-success p-ml-2"
                  >
                    <i className="pi pi-plus" />
                    &nbsp;
                    {t('addMetric')}
                  </a>
                </div>
              </div>
              <Panel>
                <MetricsListComponent view="simple" />
              </Panel>
            </div>
          )}

          {entity === 'location' && (!action || action === 'list' || action === 'create' || action === 'update') && localStorage.getItem('roles').toString().includes('role_location_read') && (
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('locationList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"} />
                  {localStorage.getItem('roles').toString().includes('role_location_write') && (
                    <a
                      onClick={() => {
                        history.push('/settings/location/create');
                      }}
                      className={"p-button  p-button-success p-ml-2"}
                    >
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addLocation')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <LocationListComponent backlink={'/settings/location'} />
              </Panel>
            </div>
          )}
          {entity === 'location' && (action === 'create' || action === 'update') && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={action === 'create' || action === 'update'}
              closeOnEscape={true}
              style={{ width: '780px' }}
              onHide={() => {
                history.push('/settings/location');
              }}
            >
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('locationUpdate') : t('locationCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"} />
                    <a
                      onClick={() => {
                        history.push('/settings/location');
                      }}
                      className={"p-button  p-button-secondary p-ml-2"}
                    >
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <LocationFormComponent backlink={'/settings/location'} />
                </Panel>
              </div>
            </Sidebar>
          )}
          {entity === 'unit' && (action === 'create' || action === 'update') && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible={action === 'create' || action === 'update'}
              closeOnEscape
              style={{ width: '780px' }}
              onHide={() => {
                history.push('/settings/unit');
              }}
            >
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('unitOfMeasureUpdate') : t('unitOfMeasureCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a
                      onClick={() => history.push('/settings/unit')}
                      className={"p-button p-button-secondary p-ml-2"}
                    >
                      <i className={"pi pi-arrow-left"}></i>&nbsp;{t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <UnitFormComponent backlink={'/settings/unit'} />
                </Panel>
              </div>
            </Sidebar>
          )}

          {entity === 'language' && roles.includes('role_language_write') && (action === 'create' || action === 'update') && (
            <Sidebar
              position="left"
              showCloseIcon={false}
              visible
              closeOnEscape
              style={{ width: '780px' }}
              onHide={() => history.push('/settings/language')}
            >
              <div className="PageContent p-px-1 p-py-3 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {id ? t('languageUpdate') : t('languageCreate')}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <a onClick={() => history.push('/settings/language')} className="p-button p-button-secondary p-ml-2">
                      <i className="pi pi-arrow-left" />&nbsp;{t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <LanguageFormComponent backlink="/settings/language" />
                </Panel>
              </div>
            </Sidebar>
          )}

          {entity === 'price-list-item' && (!action || action === 'update' || action === 'create') &&
                      <div className={"PageContent p-p-5 p-mx-auto"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('priceList')}
                            </h2>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                            <a onClick={() => {
                              history.push('/settings/price-list-item/create')
                            }}
                               className={"p-button  p-button-success p-ml-2"}>
                              <i className={"pi pi-plus"}></i>
                              &nbsp;
                              {t('addPriceList')}
                            </a>
                          </div>
                        </div>
                        <Panel>
                          <PricelistitemListComponent backlink={'/settings/price-list-item'}/>
                        </Panel>
                      </div>
                    }
                    {entity === 'price-list-item' && (action === 'create' || action === 'update') &&
                      <Sidebar position="left"
                               showCloseIcon={false}
                               visible={action === 'create' || action === 'update'}
                               closeOnEscape={true}
                               style={{width: '780px'}}
                               onHide={() => {
                                 if (action === 'create' || action === 'update') {
                                   history.push('/settings/price-list-item')
                                 }
                               }}>
                        <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {id ? t('priceListUpdate') : t('priceListCreate')}
                              </h2>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <span className={"p-mr-2"}>
          
                            </span>
                              <a onClick={() => {
                                if (action === 'create' || action === 'update') {
                                  history.push('/settings/price-list-item')
                                }
                              }}
                                 className={"p-button  p-button-secondary p-ml-2"}>
                                <i className={"pi pi-arrow-left"}></i>
                                &nbsp;
                                {t('back')}
                              </a>
                            </div>
                          </div>
                          <Panel>
                            {(action === 'create' || action === 'update') &&
                              <PricelistitemFormComponent backlink={'/settings/price-list-item'}/>
                            }
                          </Panel>
                        </div>
                      </Sidebar>
                    }
          
          <Sidebar position="left" visible={window.App.state.sidebarCompanyCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCompanyCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('addCompany')}</h2>
            <CompanyFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarCompanyUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCompanyUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('companyUpdate')}</h2>
            <CompanyFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarBankaccountCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarBankaccountCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('addBankAccountShort')}</h2>
            <BankaccountFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarBankaccountUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarBankaccountUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('bankAccountUpdate')}</h2>
            <BankaccountFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarRolegroupCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({
                       sidebarRolegroupCreate: false,
                       useEffect: true,
                     })
                   }}>
            <h2 className={"text-primary"}>{t('addRole')}</h2>
            <RolegroupFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarRolegroupUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarRolegroupUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('roleUpdate')}</h2>
            <RolegroupFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          {entity === 'roles' && (!action || action === 'update' || action === 'create') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('roleList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <a onClick={() => {
                    history.push('/settings/roles/create')
                  }}
                      className={"p-button  p-button-success p-ml-2"}>
                    <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addRole')}
                  </a>
                </div>
              </div>
              <Panel>
                <RolesListComponent backlink={'/settings/roles'}/>
              </Panel>
            </div>
          }
          {entity === 'roles' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '1440px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/settings/roles')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('roleUpdate') : t('roleCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/settings/roles')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <RolesFormComponent backlink={'/settings/roles'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }

          {entity === 'identifier' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_identifier_read') && 
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('identifierList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_identifier_write') && (
                    <a onClick={() => {
                      history.push('/settings/identifier/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addIdentifier')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <IdentifierListComponent backlink={'/settings/identifier'}/>
              </Panel>
            </div>
          }
          {entity === 'identifier' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '780px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/settings/identifier')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('identifierUpdate') : t('identifierCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/settings/identifier')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <IdentifierFormComponent backlink={'/settings/identifier'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }

          {entity === 'dashboard-template' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_dashboard_template_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('reportTemplates')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {/* <a onClick={() => {
                    history.push('/dashboard-template/create')
                  }}
                      className={"p-button  p-button-success p-ml-2"}>
                    <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addReportTemplate')}
                  </a> */}
                </div>
              </div>
              <Panel>
                <DashboardTemplateListComponent backlink={'/dashboard-template'}/>
              </Panel>
            </div>
          }
          {entity === 'dashboard-template' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '1880px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/settings/dashboard-template')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('dashboardUpdate') : t('dashboardCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/settings/dashboard-template')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <DashboardTemplateFormComponent backlink={'/settings/dashboard-template'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'dashboard-template' && (action === 'show') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <DashboardTemplateShowComponent />
            </div>
          }

          <Sidebar position="left" visible={window.App.state.sidebarProjectstatusCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjectstatusCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectStatusCreate')}</h2>
            <ProjectstatusFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarProjectstatusUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjectstatusUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectStatusUpdate')}</h2>
            <ProjectstatusFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarProjecttypeCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjecttypeCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectTypeCreate')}</h2>
            <ProjecttypeFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarProjecttypeUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjecttypeUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectTypeUpdate')}</h2>
            <ProjecttypeFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarProjectitemstatusCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjectitemstatusCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectItemStatusCreate')}</h2>
            <ProjectitemstatusFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarProjectitemstatusUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarProjectitemstatusUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('projectItemStatusUpdate')}</h2>
            <ProjectitemstatusFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarMetricsCreate} closeOnEscape={true}
                   style={{width: '980px'}}
                   onHide={() => {
                     window.App.setState({
                       sidebarMetricsCreate: false,
                     })
                   }}>
            <h2 className={"text-primary"}>{t('addMetric')}</h2>
            <MetricsFormComponent />
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarMetricsUpdate} closeOnEscape={true}
                   style={{width: '980px'}}
                   onHide={() => {
                     window.App.setState({
                       sidebarMetricsUpdate: false,
                     })
                   }}>
            <h2 className={"text-primary"}>{t('metricUpdate')}</h2>
            <MetricsFormComponent />
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarDocumenttypeCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarDocumenttypeCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('documentTypeCreate')}</h2>
            <DocumenttypeFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarDocumenttypeUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarDocumenttypeUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('documentTypeUpdate')}</h2>
            <DocumenttypeFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarDocumenttemplateCreate} closeOnEscape={true}
                   style={{width: '980px'}}
                   onHide={() => {
                     window.App.setState({sidebarDocumenttemplateCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('documentTemplateCreate')}</h2>
            <DocumenttemplateFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarDocumenttemplateUpdate} closeOnEscape={true}
                   style={{width: '980px'}}
                   onHide={() => {
                     window.App.setState({sidebarDocumenttemplateUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('documentTemplateUpdate')}</h2>
            <DocumenttemplateFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarCalendartypeCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCalendartypeCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('eventTypeCreateSpaced')}</h2>
            <CalendartypeFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarCalendartypeUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCalendartypeUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('eventTypeUpdateSpaced')}</h2>
            <CalendartypeFormComponent method="post" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmployeenationalityCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmployeenationalityCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('citizenshipCreate')}</h2>
            <EmployeenationalityFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmployeenationalityUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmployeenationalityUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('citizenshipUpdate')}</h2>
            <EmployeenationalityFormComponent method="post" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarActivitygroupCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarActivitygroupCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('activityCreate')}</h2>
            <ActivitygroupFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarActivitygroupUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarActivitygroupUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('activityUpdate')}</h2>
            <ActivitygroupFormComponent method="post" initialValues={window.App.state.props}/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarActivitysubgroupCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarActivitysubgroupCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('subactivityCreate')}</h2>
            <ActivitysubgroupFormComponent groupId={window.App.state.props} method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarActivitysubgroupUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarActivitysubgroupUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('subactivityUpdate')}</h2>
            <ActivitysubgroupFormComponent groupId={window.App.state.propsGroupId}
                                           initialValues={window.App.state.props} method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmploymentworkorderCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmploymentworkorderCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('workScheduleCreate')}</h2>
            <EmploymentworkorderFormComponent groupId={window.App.state.props} method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmploymentworkorderUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmploymentworkorderUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('workScheduleUpdate')}</h2>
            <EmploymentworkorderFormComponent initialValues={window.App.state.props} method="put"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmploymenttypeCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmploymenttypeCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('employmentFormCreate')}</h2>
            <EmploymenttypeFormComponent groupId={window.App.state.props} method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarEmploymenttypeUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarEmploymenttypeUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('employmentFormUpdate')}</h2>
            <EmploymenttypeFormComponent initialValues={window.App.state.props} method="put"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarUnasCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarUnasCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('unasConnectionCreate')}</h2>
            <UnasFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarUnasUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarUnasUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('unasConnectionUpdate')}</h2>
            <UnasFormComponent initialValues={window.App.state.props} method="put"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarPricelistitemCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarPricelistitemCreate: false})
                   }}>
            <h2 className={"text-primary"}>{t('addPriceList')}</h2>
            <PricelistitemFormComponent method="post"/>
          </Sidebar>

          <Sidebar position="left" visible={window.App.state.sidebarPricelistitemUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarPricelistitemUpdate: false})
                   }}>
            <h2 className={"text-primary"}>{t('priceListUpdate')}</h2>
            <PricelistitemFormComponent initialValues={window.App.state.props} method="put"/>
          </Sidebar>

          {/* employee tallózó */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'employee'}
            closeOnEscape={true}
            style={{width: '100%', height: '80%'}}
            onHide={() => {
              const hash = window.location.hash.replace("#", "");
              const currentPath = hash.split("?")[0];
              const vars = window.App.urlVars();
              const newVars = { ...vars };
              delete newVars.search;
              const queryParts = Object.entries(newVars)
                .filter(([_, v]) => v !== undefined && v !== null && String(v).length > 0)
                .map(([k, v]) => `${k}=${v}`);
              const query = queryParts.length ? `?${queryParts.join("&")}` : "";
              history.push(currentPath + query);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {t('employeeSearch')}
                </h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              </div>
            </div>
            <Panel>
              <EmployeeListComponent
                view={"search"}
                backlink={
                  '/settings/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>

          {/* projekt tallózó */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'project'}
            closeOnEscape={true}
            style={{width: '100%', height: '80%'}}
            onHide={() => {
              const basePath =
                '/settings/' + entity + '/' + action + (id && id !== 'undefined' ? '/' + id : '');
              history.push(basePath);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {t('projectSearch')}
                </h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              </div>
            </div>
            <Panel>
              <ProjectListComponent
                view={"search"}
                backlink={
                  '/settings/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>
        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{ fontSize: '5em' }}></i>
          <span className={"p-text-bold p-d-block "}>
            {t('moduleNoAccess')}
          </span>
          {t('moduleNoAccessContact')} {process.env.REACT_APP_DEVOPS_CONTACT} {t('emailAddressSuffix')}
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
              <a
                className={"p-button p-button-warning"}
                onClick={() => {
                  window.location.replace('/#/subscriptions');
                  window.App.forceUpdate();
                }}
              >
                <i className={"pi pi-building"}></i>&nbsp;{t('subscriptionAccountOverview')}
              </a>
            </span>
          }
        </p>
      )}
    </div>
  );
};

export default withTranslation('common')(SettingsPage);
